import React from 'react'
import Link from 'gatsby-link'

const Insurance = () => (
  <div>
    <h2>Insurance</h2>
    <p>
      I am happy to bill your insurance at no cost. Please remember that you are
      responsible for the full cost of your visit, whether or not your insurance
      company pays for the visit.
      <u>
        Please ensure that your benefits include acupuncture prior to your
        appointment.
      </u>
    </p>
    <p>
      I am a preferred provider with a number of insurance companies, including:
    </p>
    <ul>
      <li>AccessOne Consumer Health</li>
      <li>Ambetter Coordinated Care</li>
      <li>Aetna WA CAM</li>
      <li>First Choice Health</li>
      <li>Great-West Healthcare</li>
      <li>Health Allies</li>
      <li>Health Net Life</li>
      <li>Health Net Oregon</li>
      <li>Humana</li>
      <li>Lifewise</li>
      <li>Medical Resource, LLC</li>
      <li>Premera</li>
      <li>United Healthcare</li>
    </ul>
    <p>
      If you do not see your insurance company listed here, please contact me,
      as this list is subject to change. I am also able to bill many insurance
      companies, including BlueCross Blue Shield and Regence, as an out of
      network provider.
    </p>
    <p>
      I accept all PIP claims (auto accidents). If you are paying through PIP,
      please complete this form and bring it with your to your first session.
    </p>
    <p>
      I also provide super bills for you to submit to your insurance provider
      for reimbursement upon request.
    </p>
  </div>
)

export default Insurance


// WEBPACK FOOTER //
// ./src/pages/insurance.js